import type { GalleryResponse } from '@moltable/shared';
import ProjectCard from './ProjectCard';

type GallerySite = GalleryResponse['sites'][number];

interface ProjectGridProps {
  sites: GallerySite[];
}

export default function ProjectGrid({ sites }: ProjectGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {sites.map((site, index) => (
        <ProjectCard
          key={site.id}
          index={index}
          {...site}
        />
      ))}
    </div>
  );
}
